export enum AlertsType {
  FileUpload,
  StagingFileUpload,
  AccessRequest,
}
